export const REDIRECT_URL_PARAM = "redirectUrl";

export const LOGIN_CODE_URL_PARAM = "code";
